import { BANNER_GRADIENT_STYLE } from '@/components/HowToWin/helpers/constants';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { HowToWinBannerBigContent } from './HowToWinBannerBigContent';
import { HowToWinBannerBigImage } from './HowToWinBannerBigImage';
import { useHowToWinBannerCTA } from '../../hooks/useHowToWinBannerCTA';
import { useWindowIsMobile } from '@liveauctioneers/hammer-ui-core/providers';

export const HowToWinBannerBig = () => {
    const { href, onCTAClick } = useHowToWinBannerCTA();
    const isMobile = useWindowIsMobile();

    return (
        <div
            className="relative mx-auto w-full max-w-[1200px] mdMax:w-[calc(100%-40px)]"
            data-testid="howToWinBannerBig"
        >
            <div
                className={cn(
                    'relative mt-sm flex flex-col items-center justify-center gap-sm rounded-lg p-sm',
                    'smMin:mt-md smMin:h-[256px] smMin:flex-row smMin:items-center smMin:gap-2xl smMin:p-xs'
                )}
                style={BANNER_GRADIENT_STYLE}
            >
                {!isMobile && <HowToWinBannerBigImage />}
                <HowToWinBannerBigContent
                    href={href}
                    onCTAClick={onCTAClick}
                />
            </div>
        </div>
    );
};
